import { useFormContext } from "react-hook-form"
import type { BetterDocConsultationQuestionId } from "@/modules/patients/detail/better-doc/de/lib/better-doc-consultation-questionnaire-definition"
import { getDependentQuestions } from "@/modules/patients/detail/better-doc/de/lib/better-doc-consultation-questionnaire-visibility"
import type { DeBetterDocSearchFormType } from "@/modules/patients/detail/better-doc/de/schema/de-better-doc-search-schema"

export const useResetDependentAnswers = (questionId: BetterDocConsultationQuestionId) => {
  const { resetField } = useFormContext<DeBetterDocSearchFormType>()

  return () => {
    for (const dependentQuestionId of getDependentQuestions(questionId)) {
      resetField(dependentQuestionId, { defaultValue: undefined })
    }
  }
}
